export const TableRowTypes = {
  Region: "region",
  RegionPrice: "region-price",
  ForecastPrices: "forecast-prices",
  GenGroup: "gen-group",
  Portfolio: "portfolio",
  Fuel: "fuel",
};
